<template>
  <div>
    <b-card
      v-for="textVariant in textVariants"
      :key="textVariant.lang"
      :header="textVariant.lang | getLangNameEn"
      class="text-variant mb-3"
    >
      <b-card-text>
        {{textVariant.title}}
      </b-card-text>
      <b-card-text>
        {{textVariant.message}}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'PushTextVariants',

  props: {
    textVariants: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
  .text-variant .card-body,
  .text-variant .card-header {
    padding: 10px;
  }
</style>
